const styles = {
  root: theme => ({
    p: 3
  }),

  textGrey: {
    color: '#A2A2A2'
  },

  textGreen: theme => ({
    color: theme.palette.success.main
  }),

  tabWrap: {
    backgroundColor: '#FFFFFF',
    borderRadius: '0 4px 4px 4px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    p: 1.25
  },

  tabLabel: {
    fontWeight: 500,
    ml: 2.25,
    mt: 2.5
  },

  templateWrap: {
    flex: 1,
    mb: 1.25
  },

  templateHead: {
    backgroundColor: '#EFF5FC',
    border: '1px solid #D4E5F9',
    fontSize: 14,
    fontWeight: 500,
    p: 2,

    '& p': {
      fontSize: 14,
      fontWeight: 600
    }
  },

  textBox: {
    width: '100%',

    '& input': {
      p: '7px 10px',

      '&::placeholder': {
        color: '#B9B9B9',
        fontFamily: 'Lato',
        fontSize: 12,
        fontWeight: 400
      }
    },

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#E6E9EC'
    }
  },

  templateBody: {
    border: '1px solid #D4E5F9',
    borderTop: 0
  },

  templateTable: theme => ({
    '& .MuiSvgIcon-root': {
      height: 20,
      width: 20
    },

    '& td': {
      color: '#4A4A4A',
      fontSize: 13,
      lineHeight: '16px',
      p: '8px 10px'
    },

    '& th': {
      p: '8px 10px'
    },

    '& td a': {
      color: theme.palette.primary.main,

      '&:active': {
        color: theme.palette.primary.main
      },

      '&:hover': {
        color: theme.palette.secondary.main,
        textDecoration: 'underline'
      }
    }
  }),

  icdLeft: {
    flexBasis: '44.66%',
    maxWidth: '44.66%'
  },

  icdRight: {
    flexBasis: '44.66%',
    maxWidth: '44.66%'
  },

  icdCenter: {
    flexBasis: '10.66%',
    maxWidth: '10.66%'
  },

  icdCtrls: {
    alignItems: 'center',
    border: '1px solid #D4E5F9',
    bottom: 17,
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100% - 10px)',
    justifyContent: 'center',
    p: 2.5
  },

  icdCtrlBtn1: theme => ({
    backgroundColor: '#03A484',
    borderRadius: 1.25,
    maxWidth: 65,
    mb: 2.5,

    [theme.breakpoints.down('md')]: {
      minWidth: 20,
      p: 0.625
    },

    '&:hover': {
      backgroundColor: '#0DBB99'
    },

    '& svg': {
      color: '#FFFFFF'
    }
  }),

  icdCtrlBtn2: theme => ({
    backgroundColor: '#B9B9B9',
    borderRadius: 1.25,
    maxWidth: 65,
    mb: 2.5,

    [theme.breakpoints.down('md')]: {
      minWidth: 20,
      p: 0.625
    },

    '& svg': {
      color: '#FFFFFF'
    }
  }),

  icdCtrlBtn3: theme => ({
    borderRadius: 1.25,
    maxWidth: 65,

    [theme.breakpoints.down('md')]: {
      minWidth: 20,
      p: 0.625
    }
  }),

  fullWidth: {
    width: '100%'
  },

  addButton: {
    ml: '-10px',
    minWidth: 20,
    p: '5px 10px'
  },

  multiSel: {
    width: '100%',

    '&::before': {
      borderColor: 'transparent !important'
    },

    '& select': {
      overflow: 'auto',

      '&:focus': {
        backgroundColor: 'transparent'
      },

      '& option': {
        fontFamily: 'Lato',
        fontSize: 14,
        p: '5px 0'
      }
    }
  },

  underline: {
    borderBottom: '2px solid transparent',

    '&:after': {
      borderBottom: '2px solid transparent'
    }
  },

  modalWrap: {
    backgroundColor: '#FFFFFF',
    borderRadius: 1.25,
    boxShadow: '0 0 10px 10px rgba(0, 0, 0, 0.1)',
    left: '50%',
    outline: 'none',
    p: 2.5,
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)'
  },

  modalHead: {
    borderBottom: '1px solid #F9F9F9',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.12)',
    m: -2.5,
    mb: 1.25,
    p: '10px 15px',
    pb: 1.25,

    '& h2': {
      fontSize: 28,
      fontWeight: 300
    }
  },

  modalBody: {
    p: '10px 0'
  },

  modalClose: {
    position: 'absolute',
    right: 5,
    top: 5
  },

  modalFooter: {
    p: '20px 0 10px',
    textAlign: 'right'
  },

  generalTable: {
    '& td': {
      color: '#4A4A4A',
      fontSize: 13,
      lineHeight: '16px',
      p: '8px 5px',

      '& a:hover': {
        textDecoration: 'underline'
      }
    },

    '& th': {
      backgroundColor: 'transparent',
      borderBottom: '1px solid #A2A2A2',
      fontWeight: 500,
      p: '8px 5px'
    },

    '& thead': {
      backgroundColor: 'transparent'
    }
  },

  leftButton: {
    display: 'flex',
    justifyContent: 'space-between'
  }
};

export default styles;